import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  addDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  getCountFromServer,
} from 'firebase/firestore';

async function getDocumentById(firestore, collectionName, docId) {
  if (docId === null) return null;
  const docRef = doc(firestore, collectionName, docId);
  const docSnap = await getDoc(docRef);
  if (!docSnap.exists()) return null;
  const data = { ...docSnap.data(), ...{ $id: docSnap.id } };
  return data;
}

async function getCollection(
  firestore,
  collectionName,
  whereConfig,
  orderByConfig,
  limitValue
) {
  let q = collection(firestore, collectionName);

  if (whereConfig) {
    if (Array.isArray(whereConfig)) {
      whereConfig.forEach((wConfig) => {
        q = query(q, where(wConfig.key, wConfig.operator, wConfig.value));
      });
    } else {
      q = query(
        q,
        where(whereConfig.key, whereConfig.operator, whereConfig.value)
      );
    }
  }

  if (orderByConfig) {
    q = query(q, orderBy(orderByConfig.key, orderByConfig.direction));
  }
  if (limitValue) {
    q = query(q, limit(limitValue));
  }

  const querySnapshot = await getDocs(q);

  const data = querySnapshot.docs.map((doc) => {
    return { ...doc.data(), ...{ $id: doc.id } };
  });
  return data;
}

async function getCollectionCount(firestore, collectionName) {
  const collectionRef = collection(firestore, collectionName);
  const snapshot = await getCountFromServer(collectionRef);
  const count = parseInt(snapshot.data().count);
  return count;
}

async function setDocById(
  firestore,
  collectionName,
  docId,
  docData,
  merge = true
) {
  const docRef = doc(firestore, collectionName, docId);
  return await setDoc(docRef, docData, { merge: merge });
}

async function updateDocById(firestore, collectionName, docId, data = {}) {
  // Set (merge) will overwrite all values, update only updates the values in the data object
  const docRef = doc(firestore, collectionName, docId);
  return await updateDoc(docRef, data);
}

async function addDocToCollection(firestore, collectionName, docData) {
  const collectionRef = collection(firestore, collectionName);
  return await addDoc(collectionRef, docData);
}

async function deleteDocByCollectionAndId(firestore, collectionName, id) {
  const docRef = doc(firestore, collectionName, id);
  return await deleteDoc(docRef);
}

export {
  getDocumentById,
  getCollection,
  getCollectionCount,
  setDocById,
  updateDocById,
  addDocToCollection,
  deleteDocByCollectionAndId,
};
